import { Injectable } from "@angular/core";
import { StatusCodes } from "@obg/ngx.global";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { AppError, AppErrorType } from "../app-error/app-error.model";
import { CoreHttpClient } from "../http-client/http-client.service";
import { TransactionFilter } from "../wallet/wallet.model";

import { AamsDataConfigService } from "./aams-data.config";
import { AamsTransaction, GameRound, GameRoundFilter } from "./aams-data.model";

@Injectable({
	providedIn: "root",
})
export class AamsDataService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: AamsDataConfigService
	) {}

	getLastGameRound(filter: GameRoundFilter): Observable<GameRound> {
		return this.httpClient
			.get<GameRound>({
				url: this.config.getLastGameRoundEndpoint(),
				searchParams: filter,
			})
			.pipe(
				catchError((error: AppError) => {
					if (error.type === AppErrorType.NotFound) {
						return of({});
					}
					return throwError(() => error) as Observable<any>;
				})
			);
	}

	getTransactions(filter: TransactionFilter): Observable<AamsTransaction> {
		return this.httpClient
			.get<AamsTransaction>({
				url: this.config.getTransactionsEndpoint(),
				searchParams: filter,
				suppressErrorLogging: [StatusCodes.NotFound],
			})
			.pipe(
				catchError((error: AppError) => {
					if (error.type === AppErrorType.NotFound) {
						return of({
							transactions: [],
							hasMoreResults: false,
						});
					}
					return throwError(() => error);
				})
			);
	}

	getSessions(filter: TransactionFilter): Observable<AamsTransaction> {
		return this.httpClient
			.get<AamsTransaction>({
				url: this.config.getSessionsEndpoint(),
				searchParams: filter,
				suppressErrorLogging: [StatusCodes.NotFound],
			})
			.pipe(
				catchError((error: AppError) => {
					if (error.type === AppErrorType.NotFound) {
						return of({
							customerSessions: [],
							totalCustomerSessions: 0,
						});
					}
					return throwError(() => error);
				})
			);
	}
}
